export default "__VITE_ASSET__0c0ed347__"